<template>
	<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_69_160)">
			<path
				d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
				fill="#13AA52" />
			<path
				d="M50.6922 35.1125C48.1656 23.9617 42.1945 20.2953 41.5516 18.8945C40.8484 17.9063 40.1359 16.1484 40.1359 16.1484C40.1242 16.1187 40.1055 16.0664 40.0836 16.0156C40.0109 17.0039 39.9734 17.3852 39.0391 18.382C37.5922 19.5133 30.1688 25.7422 29.5648 38.4109C29.0016 50.2266 38.1 57.2672 39.3305 58.1648L39.4703 58.2641V58.2555C39.4781 58.3148 39.8609 61.068 40.1297 63.9852H41.0938C41.32 61.9231 41.659 59.875 42.1094 57.85L42.1875 57.7992C42.7379 57.4046 43.2627 56.9753 43.7586 56.5141L43.8148 56.4633C46.4305 54.0469 51.1328 48.4578 51.0867 39.5469C51.077 38.0604 50.945 36.5773 50.6922 35.1125ZM40.0273 51.4937C40.0273 51.4937 40.0273 34.9219 40.5742 34.925C41.0008 34.925 41.5531 56.3008 41.5531 56.3008C40.7938 56.2094 40.0273 52.7828 40.0273 51.4937Z"
				fill="white" />
		</g>
		<defs>
			<clipPath id="clip0_69_160">
				<rect width="80" height="80" fill="white" />
			</clipPath>
		</defs>
	</svg>
</template>